import React from 'react';

/**
 * Catálogo Técnico 2D em Vista Superior (Top View / Planta Baixa)
 * Dimensões em centímetros (cm), correspondentes à escala 1:1 do mundo virtual do Croqui 2D.
 */
export const APPLIANCE_CATALOG = [
  // COZINHA / COZINHA
  {
    id: 'cooktop_4b',
    name: 'Cooktop 4 Bocas',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 52,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 60 52" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="58" height="50" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Grade interna de vidro */}
        <rect x="5" y="5" width="50" height="42" rx="2" fill="none" stroke={stroke} strokeWidth={1} strokeDasharray="3,2" />
        {/* 4 Bocas com trempes */}
        <circle cx="18" cy="16" r="7" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="18" cy="16" r="3" fill={stroke} />
        <circle cx="42" cy="16" r="7" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="42" cy="16" r="3" fill={stroke} />
        <circle cx="18" cy="36" r="7" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="18" cy="36" r="3" fill={stroke} />
        <circle cx="42" cy="36" r="7" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="42" cy="36" r="3" fill={stroke} />
        {/* Manípulos de controle */}
        <circle cx="53" cy="16" r="1.5" fill={stroke} />
        <circle cx="53" cy="23" r="1.5" fill={stroke} />
        <circle cx="53" cy="30" r="1.5" fill={stroke} />
        <circle cx="53" cy="37" r="1.5" fill={stroke} />
      </svg>
    )
  },
  {
    id: 'cooktop_5b',
    name: 'Cooktop 5 Bocas',
    category: 'Cozinha',
    defaultWidth: 75,
    defaultHeight: 52,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 75 52" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="73" height="50" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        <rect x="5" y="5" width="65" height="42" rx="2" fill="none" stroke={stroke} strokeWidth={1} strokeDasharray="3,2" />
        {/* Boca central grande (tripla chama) */}
        <circle cx="37.5" cy="26" r="10" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="37.5" cy="26" r="4" fill={stroke} />
        {/* 4 Bocas laterais */}
        <circle cx="16" cy="16" r="6" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="16" cy="16" r="2.5" fill={stroke} />
        <circle cx="59" cy="16" r="6" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="59" cy="16" r="2.5" fill={stroke} />
        <circle cx="16" cy="36" r="6" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="16" cy="36" r="2.5" fill={stroke} />
        <circle cx="59" cy="36" r="6" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="59" cy="36" r="2.5" fill={stroke} />
      </svg>
    )
  },
  {
    id: 'sink_single',
    name: 'Cuba Simples Inox',
    category: 'Cozinha',
    defaultWidth: 50,
    defaultHeight: 40,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 50 40" width="100%" height="100%" style={{ overflow: 'visible' }}>
        {/* Borda externa / bancada */}
        <rect x="1" y="1" width="48" height="38" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Cuba interna */}
        <rect x="6" y="8" width="38" height="26" rx="4" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        {/* Válvula / Ralo */}
        <circle cx="25" cy="21" r="3.5" fill="none" stroke={stroke} strokeWidth={1.5} />
        <circle cx="25" cy="21" r="1.5" fill={stroke} />
        {/* Torneira monocomando no topo */}
        <circle cx="25" cy="4.5" r="2.5" fill={stroke} />
        <path d="M 25 4.5 L 25 11" stroke={stroke} strokeWidth={2} strokeLinecap="round" />
      </svg>
    )
  },
  {
    id: 'sink_double',
    name: 'Cuba Dupla Inox',
    category: 'Cozinha',
    defaultWidth: 80,
    defaultHeight: 45,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 80 45" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="78" height="43" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Cuba Esquerda */}
        <rect x="5" y="9" width="32" height="30" rx="3" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="21" cy="24" r="3" fill="none" stroke={stroke} strokeWidth={1.5} />
        <circle cx="21" cy="24" r="1" fill={stroke} />
        {/* Cuba Direita */}
        <rect x="43" y="9" width="32" height="30" rx="3" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="59" cy="24" r="3" fill="none" stroke={stroke} strokeWidth={1.5} />
        <circle cx="59" cy="24" r="1" fill={stroke} />
        {/* Torneira Central */}
        <circle cx="40" cy="5" r="2.5" fill={stroke} />
        <path d="M 40 5 L 40 12" stroke={stroke} strokeWidth={2} strokeLinecap="round" />
      </svg>
    )
  },
  {
    id: 'fridge_standard',
    name: 'Geladeira Padrão',
    category: 'Cozinha',
    defaultWidth: 70,
    defaultHeight: 70,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 70 70" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="68" height="68" rx="2" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Puxador frontal estilizado e divisória de porta */}
        <line x1="1" y1="62" x2="69" y2="62" stroke={stroke} strokeWidth={1.5} />
        <rect x="25" y="64" width="20" height="3" rx="1" fill={stroke} />
        {/* Ícone sutil de ventilação / freezer */}
        <line x1="15" y1="15" x2="55" y2="15" stroke={stroke} strokeWidth={1} strokeDasharray="4,4" />
        <line x1="15" y1="30" x2="55" y2="30" stroke={stroke} strokeWidth={1} strokeDasharray="4,4" />
        <line x1="15" y1="45" x2="55" y2="45" stroke={stroke} strokeWidth={1} strokeDasharray="4,4" />
      </svg>
    )
  },
  {
    id: 'fridge_side_by_side',
    name: 'Geladeira Side by Side',
    category: 'Cozinha',
    defaultWidth: 90,
    defaultHeight: 75,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 90 75" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="88" height="73" rx="2" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Divisão vertical de duas portas */}
        <line x1="40" y1="1" x2="40" y2="74" stroke={stroke} strokeWidth={strokeWidth} />
        {/* Puxadores duplos frontais */}
        <line x1="1" y1="67" x2="89" y2="67" stroke={stroke} strokeWidth={1} />
        <rect x="30" y="69" width="8" height="3" rx="1" fill={stroke} />
        <rect x="42" y="69" width="8" height="3" rx="1" fill={stroke} />
      </svg>
    )
  },
  {
    id: 'oven_tower',
    name: 'Torre Quente (Forno/Micro)',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 60,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 60 60" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="58" height="58" rx="2" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Painel do forno */}
        <rect x="6" y="6" width="48" height="44" rx="2" fill="none" stroke={stroke} strokeWidth={1.5} />
        <circle cx="30" cy="28" r="10" fill="none" stroke={stroke} strokeWidth={1.5} strokeDasharray="3,2" />
        {/* Puxador largo frontal */}
        <rect x="12" y="52" width="36" height="3" rx="1" fill={stroke} />
      </svg>
    )
  },

  // LAVANDERIA
  {
    id: 'washing_machine',
    name: 'Lava e Seca Frontal',
    category: 'Lavanderia',
    defaultWidth: 60,
    defaultHeight: 60,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 60 60" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="58" height="58" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Escotilha redonda vista de cima */}
        <circle cx="30" cy="30" r="19" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        <circle cx="30" cy="30" r="14" fill="none" stroke={stroke} strokeWidth={1} strokeDasharray="3,3" />
        {/* Painel superior de comandos */}
        <line x1="1" y1="12" x2="59" y2="12" stroke={stroke} strokeWidth={1.5} />
        <circle cx="48" cy="6" r="3" fill="none" stroke={stroke} strokeWidth={1} />
        <rect x="8" y="4" width="14" height="4" rx="1" fill={stroke} />
      </svg>
    )
  },
  {
    id: 'laundry_tank',
    name: 'Tanque / Cuba Lavanderia',
    category: 'Lavanderia',
    defaultWidth: 50,
    defaultHeight: 50,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 50 50" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="48" height="48" rx="3" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Cuba interna */}
        <rect x="6" y="10" width="38" height="34" rx="3" fill="none" stroke={stroke} strokeWidth={strokeWidth} />
        {/* Frisos esfregador de tanque */}
        <line x1="10" y1="16" x2="40" y2="16" stroke={stroke} strokeWidth={1} />
        <line x1="10" y1="21" x2="40" y2="21" stroke={stroke} strokeWidth={1} />
        <line x1="10" y1="26" x2="40" y2="26" stroke={stroke} strokeWidth={1} />
        <circle cx="25" cy="36" r="2.5" fill={stroke} />
        {/* Torneira */}
        <circle cx="25" cy="5" r="2.5" fill={stroke} />
      </svg>
    )
  },

  // MÓDULOS / ARMÁRIOS
  {
    id: 'cabinet_base',
    name: 'Módulo Balcão (Inferior)',
    category: 'Módulos',
    defaultWidth: 60,
    defaultHeight: 60,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 60 60" width="100%" height="100%" style={{ overflow: 'visible' }}>
        <rect x="1" y="1" width="58" height="58" rx="2" fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
        {/* Diagonais técnicas indicando módulo inferior */}
        <line x1="1" y1="1" x2="59" y2="59" stroke={stroke} strokeWidth={1} strokeDasharray="4,4" />
        <line x1="1" y1="59" x2="59" y2="1" stroke={stroke} strokeWidth={1} strokeDasharray="4,4" />
        {/* Linha frontal de porta */}
        <line x1="1" y1="56" x2="59" y2="56" stroke={stroke} strokeWidth={strokeWidth} />
      </svg>
    )
  },
  {
    id: 'cabinet_upper',
    name: 'Módulo Aéreo (Superior)',
    category: 'Módulos',
    defaultWidth: 60,
    defaultHeight: 35,
    renderSvg: ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = 'transparent' }) => (
      <svg viewBox="0 0 60 35" width="100%" height="100%" style={{ overflow: 'visible' }}>
        {/* Módulo aéreo tracejado (convenção de arquitetura para elementos suspensos) */}
        <rect x="1" y="1" width="58" height="33" rx="2" fill={fill} stroke={stroke} strokeWidth={strokeWidth} strokeDasharray="5,3" />
        <line x1="30" y1="1" x2="30" y2="34" stroke={stroke} strokeWidth={1} strokeDasharray="3,3" />
      </svg>
    )
  }
];

export const getApplianceItem = (id) => APPLIANCE_CATALOG.find(item => item.id === id);
